module.exports = __webpack_public_path__ + "static/character-3-b5fe4263e8943fafb492c840535259af.svg";